import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AICharacterButton from './AICharacterButton';
import Button from './Button';
import ScreenTransition from './ScreenTransition';

function AISelector() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState(null);

  const handleSelect = (type) => {
    setSelectedType(type);
    navigate(`/play/${type}`);
  };

  return (
    <ScreenTransition direction="right">
      <div className="flex flex-col items-center justify-center">
        <Button onClick={() => navigate('/')} className="w-52">
          Back
        </Button>

        <div className="p-6 rounded-lg bg-transparent">
          <div className="flex gap-8 mb-8">
            <AICharacterButton
              type="random"
              onClick={() => handleSelect('random')}
              selected={selectedType === 'random'}
            />
            <AICharacterButton
              type="normal"
              onClick={() => handleSelect('normal')}
              selected={selectedType === 'normal'}
            />
          </div>
        </div>
      </div>
    </ScreenTransition>
  );
}

export default AISelector; 
